import { Dispatch, SetStateAction } from "react"
import styled from "styled-components"

import { spacing, TSelectOption } from "@minuthq/meatball-ui-react"

import { HomeFilterDropdownSelect } from "src/components/Filter/HomeFilterDropdown"
import { SearchFilter } from "src/components/Filter/SearchFilter"
import { useOrganization } from "src/data/organizations/hooks/useOrganization"
import { useFetchMembers } from "src/data/organizations/queries/memberQueries"
import { useTranslate } from "src/i18n/useTranslate"
import { DropdownMultiSelect } from "src/ui/DropdownSelect/DropdownMultiSelect"

export function TaskFilters({
  homeIds,
  setHomeIds,
  assigneeIds,
  setAssigneeIds,
  searchString,
  setSearchString,
}: {
  homeIds: string[]
  setHomeIds: Dispatch<SetStateAction<string[]>>
  assigneeIds: string[]
  setAssigneeIds: Dispatch<SetStateAction<string[]>>
  searchString: string
  setSearchString: Dispatch<SetStateAction<string>>
}) {
  const { tPlaceholder } = useTranslate()

  return (
    <FilterRowContainer>
      <SearchFilter
        placeholder={tPlaceholder("Search for task")}
        onChange={setSearchString}
        initialValue={searchString}
        delay={500}
        disabled={false}
      />
      <HomeFilterDropdownSelect homeIds={homeIds} setHomeIds={setHomeIds} />
      <AssigneeDropdownSelect
        assigneeIds={assigneeIds}
        setAssigneeIds={setAssigneeIds}
      />
    </FilterRowContainer>
  )
}

function AssigneeDropdownSelect({
  assigneeIds,
  setAssigneeIds,
}: {
  assigneeIds: string[]
  setAssigneeIds: Dispatch<SetStateAction<string[]>>
}) {
  const { orgId } = useOrganization()
  const { tPlaceholder } = useTranslate()
  const { data: users } = useFetchMembers({
    orgId,
  })

  function handleAssigneeChange({
    checked,
    option,
  }: {
    checked: boolean
    option: TSelectOption<string>
  }) {
    if (checked) {
      setAssigneeIds((prev) => Array.from(new Set([...prev, option.value])))
    } else {
      setAssigneeIds((prev) => prev.filter((o) => o !== option.value))
    }
  }

  const userOptions =
    users?.members?.map((member) => ({
      label: member.name,
      value: member.member_id,
    })) ?? []

  return (
    <DropdownMultiSelect
      label={tPlaceholder("Assignee")}
      placeholder={tPlaceholder("Search for assignee")}
      options={userOptions}
      selectedValues={assigneeIds}
      onChange={handleAssigneeChange}
      onClearSelection={() => setAssigneeIds([])}
    />
  )
}

const FilterRowContainer = styled.div`
  display: flex;
  gap: ${spacing.M};
  margin-bottom: ${spacing.L};
  align-items: center;
`
